module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAA40lEQVQoFWNgoDVgBFkwa9asZf///4/EZRkjI+PStLS0GJA8E1RRBJR+DJT8C2UjU1EwDlgD0HSgOsaXQFPkgXQHTBJGg+RhbJgNDEBBcaDTpgJpuGlARdeABiyFKQbRcA1QwUygBkUoeysLC4tFampqHJC/CyqG0AA06QIQxwHxQ6BkB9B5fsnJyZ+B/H9A/m2YBhYQAyh4goODwyUuLu4rkLsYJJaeng6iMABYA9AZD3/8+BEwe/ZskGkoACgHcjYfTBCsgY2NLeP379/6QEF4aMAUMDEx/ePj48NuHUwRPhoAwLVDzPHpjkUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/look.png
// module id = pq5a
// module chunks = 0